import { type Beneficiary, type Operation, type User } from "./models.js";

export const TREEZOR_PEP_USER_TAG_SUFFIX = "-pep";

export const isTreezorUserPep = (userTag: User["userTag"] | undefined) =>
  !!userTag?.endsWith(TREEZOR_PEP_USER_TAG_SUFFIX);

export const getTreezorOperationCounterparty = (
  t: Operation,
  beneficiaries: Map<string, Omit<Beneficiary, "id"> & { id: string }>,
):
  | {
      name: string | undefined;
      iban: string | undefined;
    }
  | undefined => {
  switch (t.initialFlow) {
    case "payin": {
      return {
        name: t.metadata.ibanFullname || t.metadata.debtorName || undefined,
        iban: t.metadata.dbtrIBAN || undefined,
      };
    }
    case "payinRefund": {
      return {
        name: t.metadata.ibanFullName || t.metadata.debtorName || undefined,
        iban: t.metadata.dbtrIBAN || undefined,
      };
    }
    case "payout": {
      return {
        name: t.metadata.beneficiaryName || undefined,
        iban: beneficiaries.get(t.metadata.beneficiaryId)?.metadata?.iban,
      };
    }
    case "payoutRefund": {
      return {
        name: t.metadata.beneficiaryName || undefined,
        iban: t.metadata.beneficiaryId
          ? beneficiaries.get(t.metadata.beneficiaryId)?.metadata?.iban
          : undefined,
      };
    }
    case "cardTransaction": {
      return {
        name: t.metadata.optimizedMerchantName || t.metadata.mid.name || undefined,
        iban: undefined,
      };
    }
    case "transfer": {
      if (t.direction === "CREDIT") {
        return {
          name:
            t.metadata.debtorLegalName ||
            `${t.metadata.debtorFirstName} ${t.metadata.debtorLastName}`.trim() ||
            t.metadata.debtorWalletEventName ||
            undefined,
          iban: undefined,
        };
      }
      return {
        name:
          t.metadata.creditorLegalName ||
          `${t.metadata.creditorFirstName} ${t.metadata.creditorLastName}`.trim() ||
          t.metadata.creditorWalletEventName ||
          undefined,
        iban: undefined,
      };
    }
    case "chargeback": {
      return undefined;
    }
  }
};

export const getTreezorOperationLabelAndReference = (
  t: Operation,
): {
  label: string | undefined;
  reference: string | undefined;
} => {
  switch (t.initialFlow) {
    case "payin":
    case "payinRefund": {
      return {
        label: t.metadata.messageToUser || undefined,
        reference: t.metadata.ibanTxEndToEndId || undefined,
      };
    }
    case "payout":
    case "payoutRefund": {
      return {
        label: t.metadata.label || undefined,
        reference: t.metadata.endToEndId || undefined,
      };
    }
    case "transfer": {
      return {
        label: t.metadata.label || undefined,
        reference: undefined,
      };
    }
    case "chargeback": {
      return {
        label: undefined,
        reference: t.metadata.transactionReference || undefined,
      };
    }
    case "cardTransaction": {
      return {
        label: undefined,
        reference: undefined,
      };
    }
  }
};
